import { IPublisher } from '@/Interfaces/Publisher.interface';
import classNames from 'classnames';

interface IProps {
  publishers: IPublisher[];
  className?: string;
}

const PublisherList = ({ publishers = [], className }: IProps) => {
  return (
    <ul className={classNames('overflow-y-auto bg-[#E8E8E8]/40', className)}>
      {publishers.map(({ name, id: publisherId }: IPublisher) => (
        <li key={publisherId} className={classNames('px-3 py-1 rounded-md text-[16px] text-[#303030]')}>
          {name}
        </li>
      ))}
    </ul>
  );
};

export default PublisherList;
